
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("dPS3E"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("1dvP0"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _42Yu6BsWIj",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $cozmU.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $cozmU.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $8s9DV.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $kBr4q.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $kBr4q.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("dPS3E", function(module, exports) {

let $a129f88ad1bb7bc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a129f88ad1bb7bc0$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("1dvP0", function(module, exports) {

let $0e2fb077491b1f30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0e2fb077491b1f30$var$load("kT6dz"),
    $0e2fb077491b1f30$var$load("5SsDI"),
    $0e2fb077491b1f30$var$load("aqs28"),
    $0e2fb077491b1f30$var$load("7I4uK"),
    $0e2fb077491b1f30$var$load("hUbK8"),
    $0e2fb077491b1f30$var$load("kUYvu"),
    $0e2fb077491b1f30$var$load("kGZ8W"),
    $0e2fb077491b1f30$var$load("8yk9S"),
    $0e2fb077491b1f30$var$load("iOfkQ"),
    $0e2fb077491b1f30$var$load("5KHgm"),
    $0e2fb077491b1f30$var$load("211bN"),
    $0e2fb077491b1f30$var$load("blNQo"),
    $0e2fb077491b1f30$var$load("bRoHi"),
    $0e2fb077491b1f30$var$load("4M5us"),
    $0e2fb077491b1f30$var$load("hoo42"),
    $0e2fb077491b1f30$var$load("lPKve"),
    $0e2fb077491b1f30$var$load("dmzjI"),
    $0e2fb077491b1f30$var$load("jrIva"),
    $0e2fb077491b1f30$var$load("7OhMs"),
    $0e2fb077491b1f30$var$load("krOnx"),
    $0e2fb077491b1f30$var$load("7SteV"),
    $0e2fb077491b1f30$var$load("1cQg7"),
    $0e2fb077491b1f30$var$load("3dYyy"),
    $0e2fb077491b1f30$var$load("jqoep"),
    $0e2fb077491b1f30$var$load("cN2rp"),
    $0e2fb077491b1f30$var$load("aKpCc"),
    $0e2fb077491b1f30$var$load("fRhcd"),
    $0e2fb077491b1f30$var$load("6w94x"),
    $0e2fb077491b1f30$var$load("3nRrI"),
    $0e2fb077491b1f30$var$load("kfGHh"),
    $0e2fb077491b1f30$var$load("lIiD7"),
    $0e2fb077491b1f30$var$load("bJbqV"),
    $0e2fb077491b1f30$var$load("hLB9K"),
    $0e2fb077491b1f30$var$load("fKQ9j"),
    $0e2fb077491b1f30$var$load("i7NGK"),
    $0e2fb077491b1f30$var$load("hpDuu"),
    $0e2fb077491b1f30$var$load("lWstc"),
    $0e2fb077491b1f30$var$load("ea3NB"),
    $0e2fb077491b1f30$var$load("dxcsb"),
    $0e2fb077491b1f30$var$load("gQrOI"),
    $0e2fb077491b1f30$var$load("6wr18"),
    $0e2fb077491b1f30$var$load("59hV4"),
    $0e2fb077491b1f30$var$load("cGkFm"),
    $0e2fb077491b1f30$var$load("5jY7k"),
    $0e2fb077491b1f30$var$load("a0CUH"),
    $0e2fb077491b1f30$var$load("ffEVr"),
    $0e2fb077491b1f30$var$load("do0Fh"),
    $0e2fb077491b1f30$var$load("cZjWF"),
    $0e2fb077491b1f30$var$load("lIK0s"),
    $0e2fb077491b1f30$var$load("ckVWI"),
    $0e2fb077491b1f30$var$load("9LDVS"),
    $0e2fb077491b1f30$var$load("kiMHu"),
    $0e2fb077491b1f30$var$load("05hOp"),
    $0e2fb077491b1f30$var$load("h1KXn"),
    $0e2fb077491b1f30$var$load("fwbNS"),
    $0e2fb077491b1f30$var$load("9TOep"),
    $0e2fb077491b1f30$var$load("4g6rd"),
    $0e2fb077491b1f30$var$load("YPUYk"),
    $0e2fb077491b1f30$var$load("hhss7"),
    $0e2fb077491b1f30$var$load("7EorR"),
    $0e2fb077491b1f30$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.a161877b.js.map
